// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__13L9B","icons":"NavigationItems_icons__2DL0D"};